// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a60ec93e","455":"5182209e","977":"d114d93e"}[chunkId] + ".chunk.js";
};